import { useSubscriptionStore } from '@stores/subscription'

import amplitudeConf from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

interface UseModalRetrySuccessReturn {
  name: string
  title: ComputedRef<string>
  btnText: string
  setSubmit: () => void
  setClose: () => void
}

export const useModalRetrySuccess = (): UseModalRetrySuccessReturn => {
  const subscriptionStore = useSubscriptionStore()

  const name = 'retry_payment_success'
  const btnText = 'Got it'

  const title = computed<string>(() => {
    const id = subscriptionStore.getPaymentRetrySubscriptionId
    const value = id ? `#${id}` : ''
    return `Subscription ${value} renewed successfully!`
  })

  onMounted(() => {
    trackEvent(amplitudeConf.events.popupView, {
      popup_name: name,
      popup_title: title.value,
    })
  })

  const setSubmit = (): void => {
    trackEvent(amplitudeConf.events.clickButton, {
      button_name: name,
      button_text: btnText,
    })
    subscriptionStore.setModalPaymentRetrySuccess(false)
  }

  const setClose = (): void => {
    trackEvent(amplitudeConf.events.clickCancel, {
      button_name: name,
    })
    subscriptionStore.setModalPaymentRetrySuccess(false)
  }

  return {
    name,
    title,
    btnText,
    setSubmit,
    setClose,
  }
}
